import React from "react"
import AdfoxAdaptive from "components/AdFoxAdaptive"


export function AdfoxSticky({isFull, isDesktop, options}) {
    if (!options) {
        return null
    }

    const option = isFull ? (isDesktop ? options.fullPc : options.fullMob) : (isDesktop ? options.prevPc : options.prevMob)

    if (!option) {
        return null;
    }

    return isDesktop ? (
        <AdfoxAdaptive options={option}/>
    ) : (
        <div style={{height: "600px"}}>
            <div className="sticky-block">
                <div className="sticky-block-content">
                    <AdfoxAdaptive options={option}/>
                </div>
            </div>
        </div>
    )
}
